import React, { useEffect, useRef } from "react";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import Carousel from "nuka-carousel";
import PlansBTableContainer from "Containers/PlansBTableContainer";
import {
	BottomPoints,
	LeftArrow,
	RightArrow,
	StylesForButtons,
} from "ComponentsUI/CarouselComponents";

const useStyles = createUseStyles((theme) => ({
	root: {},
	textH2: {
		minHeight: "30px",
		fontFamily: theme.fonts.bold,
		fontSize: "30px",
		lineHeight: "1",
		textAlign: "center",
		color: theme.palette.colors.white,
		wordWrap: "break-word",
		zIndex: "1",
	},
	array: {
		color: theme.palette.colors.purplishBlue,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		textH2: {
			fontSize: "26px",
			minHeight: "26px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		textH2: {
			fontSize: "22px",
			minHeight: "22px",
		},
	},
}));

const Tariffication404 = (props) => {
	let classes = useStyles();
	let isMobile = props.windowSizes.xs;
	let carouselRef = useRef(null);
	useEffect(() => {}, []);
	let decorator = [
		{
			component: (props) => <LeftArrow {...props} className={classes.array} />,
			position: "CenterLeft",
		},
		{
			component: (props) => <RightArrow {...props} className={classes.array} />,
			position: "CenterRight",
		},
		{
			component: (props) => (
				<BottomPoints {...props} getButtonStyles={StylesForButtons.greyPointsTariffs} />
			),
			position: "BottomCenter",
		},
	];
	let tariffList = props.tariffs.map((elem, index) => (
		<PlansBTableContainer
			key={index}
			tariffs={[elem]}
			datatest="404_tariff_list"
			pageName="page_404"
			is404={true}
		/>
	));

	return (
		<Container>
			<h2 className={classes.textH2}>{props.textH2}</h2>
			{!isMobile && (
				<PlansBTableContainer
					tariffs={props.tariffs}
					datatest="404_tariff_list"
					pageName="page_404"
					is404={true}
				/>
			)}
			{isMobile && (
				<Carousel
					ref={carouselRef}
					wrapAround={true}
					swiping={false}
					dragging={false}
					decorators={tariffList?.length != 1 ? decorator : null}
					needRecalculateHeight={true}
					heightMode="auto"
				>
					{tariffList}
				</Carousel>
			)}
		</Container>
	);
};

export default Tariffication404;
